import React, { createContext, useContext, useEffect, useState } from 'react';
import telugu from './te.json';

const LanguageContext = createContext({ language: 'en', t: text => text });
export function LanguageProvider({ children }) {
  // Start in English so the browser matches the prerendered page during hydration.
  const [language, setLanguage] = useState('en');
  useEffect(() => {
    try { if (localStorage.getItem('practice-language') === 'te') setLanguage('te'); } catch (_) {}
  }, []);
  useEffect(() => { document.documentElement.lang = language; }, [language]);
  const toggleLanguage = () => setLanguage(current => {
    const next = current === 'en' ? 'te' : 'en';
    try { localStorage.setItem('practice-language', next); } catch (_) {}
    return next;
  });
  const t = text => {
    if (language !== 'te' || typeof text !== 'string') return text;
    const key = text.trim();
    if (!telugu[key]) return text;
    return text.replace(key, telugu[key]);
  };
  return <LanguageContext.Provider value={{ language, toggleLanguage, t }}>{children}</LanguageContext.Provider>;
}
export const useLanguage = () => useContext(LanguageContext);
export function LanguageToggle({ floating = false }) {
  const { language, toggleLanguage } = useLanguage();
  return <button type="button" className={'language-toggle ' + (floating ? 'language-toggle-floating' : 'language-toggle-desktop')}
    onClick={toggleLanguage} aria-label={language === 'en' ? 'తెలుగులో చూడండి' : 'Switch to English'}>
    <span aria-hidden="true">🌐</span> <span lang={language === 'en' ? 'te' : 'en'}>{language === 'en' ? 'తెలుగు' : 'English'}</span>
  </button>;
}

export function LocalizedText({ children }) { const { t } = useLanguage(); return t(children); }
